"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=base-query.js.map